export default __webpack_public_path__ + "70f6edd619fc610ad59b7671cc7d0691.svg";